import React from 'react'
import '../../../styles/fontSizes.scss'
import "./tabButton.scss"
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const TabButton = ({text, value, textSize, isDefault, groupName, className, handleChange}) =>{
    return(
        <div className = {`${className?className:""} font-size--${textSize?textSize:"1"} tab-button__container`}>
            <input id ={value} onChange = {handleChange} label={text} type="radio" name={groupName} value={value} defaultChecked={isDefault?isDefault:false}/>
            <label htmlFor={value}>{text}</label>
        </div>
    )
}

export default TabButton;